/**
 * Contador HH:MM:SS.
 * @param {string|HTMLElement} countdownRef - ID del contenedor.
 * @param {string|HTMLElement} bannerRef - ID del banner (opcional).
 * @param {string|LiquidVar} deadlineInput - Date en formato 20 12 2025 22:59:00
 * @returns {{ stop: () => void }}
 */
function startCountdown(countdownRef, bannerRef = null, deadlineInput = null) {
  const countdown = typeof countdownRef === 'string' ? document.getElementById(countdownRef) : countdownRef;
  const banner = bannerRef
    ? (typeof bannerRef === 'string' ? document.getElementById(bannerRef) : bannerRef)
    : null;

  if (!countdown) throw new Error('countdown element not found');

  const deadline = new Date(formatDate(deadlineInput));

  if (!isValidDate(deadline)) throw new Error('invalid or missing deadline');

  mountFixedSkeleton(countdown);
  paintDigits(countdown, '00', '00', '00');

  const timer = setInterval(tick, 1000);
  tick();

  return { stop };

  function stop() { clearInterval(timer); }

  function tick() {
    const now = new Date();
    const diff = deadline.getTime() - now.getTime();

    if (diff <= 0) {
      clearInterval(timer);
      paintDigits(countdown, '00', '00', '00');
      if (banner) banner.classList.add('d-none');
      return;
    }

    const total = Math.floor(diff / 1000);
    const days = Math.floor(total / 86400);
    let hours = Math.floor((total % 86400) / 3600) + days * 24;
    const mins = Math.floor((total % 3600) / 60);
    const secs = total % 60;

    const hh = String(Math.min(hours, 99)).padStart(2, '0');
    const mm = String(mins).padStart(2, '0');
    const ss = String(secs).padStart(2, '0');

    paintDigits(countdown, hh, mm, ss);
  }
}

/** Monta HH:MM:SS fijo (2 dígitos de hora). */
function mountFixedSkeleton(container) {
  const frag = document.createDocumentFragment();
  for (let i = 0; i < 2; i++) frag.appendChild(makeDigit());
  frag.appendChild(makeSep());
  frag.appendChild(makeDigit());
  frag.appendChild(makeDigit());
  frag.appendChild(makeSep());
  frag.appendChild(makeDigit());
  frag.appendChild(makeDigit());
  container.innerHTML = '';
  container.appendChild(frag);

  function makeSep() {
    const s = document.createElement('span');
    s.className = 'cd-sep';
    s.textContent = ':';
    return s;
  }
  function makeDigit() {
    const s = document.createElement('span');
    s.className = 'cd-digit';
    return s;
  }
}

/** Pinta HH:MM:SS en nodos ya montados. */
function paintDigits(container, hh, mm, ss) {
  const nodes = container.querySelectorAll('.cd-digit');
  const values = (hh + mm + ss).split('');
  nodes.forEach((n, i) => { n.textContent = values[i] || '0'; });
}

/** Utilidad */
function isValidDate(d) { return d instanceof Date && !isNaN(d.getTime()); }

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { startCountdown };
} else if (typeof window !== 'undefined') {
  window.startCountdown = startCountdown;
}

function formatDate(date) {
  const [day, month, year, time] = date.split(' ');
  return `${year}-${month}-${day}T${time}`;
}